import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'

import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  SpreadsheetBackground,
} from '@/components/ui'
import { authLoaders } from '@/modules/auth'

export const Route = createFileRoute('/welcome')({
  staticData: { title: 'Welcome' },
  beforeLoad: async () => {
    const session = await authLoaders().getSession()
    if (!session) throw redirect({ to: '/login' })
  },
  component: WelcomePageView,
})

function WelcomePageView() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 md:px-8 lg:px-6 py-6 sm:py-8 md:py-10 lg:py-8 relative overflow-hidden flex items-center justify-center">
      <SpreadsheetBackground />
      <Card className="w- p-10 z-10 w-full max-w-screen-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-2xl font-semibold tracking-tight text-center">
            Congratulations!
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p>Your account is ready!</p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={() => navigate({ to: '/' })}>Access platform</Button>
        </CardFooter>
      </Card>
    </div>
  )
}
